module.exports = __webpack_public_path__ + "static/img/suv-green.faed60c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/suv-green.svg
// module id = JcV7
// module chunks = 74